<template>
  <div class="row">
    <div class="col-12">
      <div class="progress-header">
        <span class="step-info">Step {{ activeStep + 1 }} of {{ steps.length }}</span>
        <span class="step-info">{{ currentStepName }}</span>
      </div>
      <div class="progress-container">
        <div class="progress-line">
          <div 
            class="progress-fill"
            :style="{ width: progressPercentage + '%' }"
          ></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ProgressSteps',
  props: {
    steps: {
      type: Array,
      required: true,
      validator: (steps) => {
        return steps.every(step => step.hasOwnProperty('name'));
      }
    },
    activeStep: {
      type: Number,
      default: 0,
      validator: (value) => value >= 0
    }
  },
  computed: {
    progressPercentage() {
      if (this.steps.length === 0) return 0;
      return ((this.activeStep + 1) / this.steps.length) * 100;
    },
    currentStepName() {
      const step = this.steps && this.steps[this.activeStep];
      return step && step.name ? step.name : '';
    }
  }
};
</script>

<style scoped>

.progress-steps {
  width: 100%;
  max-width: 800px;
  margin: 0 auto;
}

.progress-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  
}

.step-info {
    font-weight: 500;
    font-size: 0.875rem;
    line-height: 1.25rem;
    color: #737373;
}

.progress-container {
  width: 100%;
  margin-top: 0.5rem;
}

.progress-line {
  width: 100%;
  height: 0.5rem;
  background-color: #e5e5e5;
  border-radius: 9999px;
  overflow: hidden;
  position: relative;
}

.progress-fill {
  height: 100%;
  background-color: #171717;
  border-radius: 9999px;
  transition: width 0.3s ease;
}

/* Responsive */
@media (max-width: 768px) {
  .progress-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  }
  
  .step-title {
    font-size: 13px;
  }
  
  .step-counter {
    font-size: 13px;
  }
}

@media (max-width: 480px) {
  .row {
    padding: 15px;
  }
  
  .step-title {
    font-size: 12px;
  }
  
  .step-counter {
    font-size: 12px;
  }
  
  .progress-line {
    height: 3px;
  }
}
</style>
